// ----------------------------------------------------------------------
// <copyright file="Izenda.Secutiry.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var m = require('mobx');
  var trackable = require('share/tracking/Izenda.Trackable');
  var commonMessages = require('share/messages/Izenda.CommonMessages');
  var localizer = require('share/localization/Izenda.Localizer');
  var QuerySourceTree = require('./Izenda.QuerySourceTreeMultiLevel');
  var SecurityRulesSet = require('./Izenda.SecurityRulesSet');
  var { reduce, isObject, findIndex, includes, filter, forEach, map } = require('lodash/fp');

  function Security() {
    this.tenantFieldDefaultValue = '';
    this.showTenantFieldDefaultValue = true;
    this.renderHtmlInReportViewerDefaultValue = false;

    var props = {
      tenantFieldValue: '',
      tenantFields: [],
      showTenantFieldValue: false,
      renderHtmlInReportViewerValue: false,
      renderhtmlexport:false,
      tenantId: null,
      errors: [],
      isSystemMode: true,
      alertMessage: commonMessages.EMPTY_MESSAGE,
      modified: null,

      dataSecurityRuleSets: [],
      rowLevelSecurityStepNumber: 1,
      dataSourceQuerySourceTree: new QuerySourceTree([], null, true),
      fieldQuerySourceTree: new QuerySourceTree([], null, true)
    };

    m.extendObservable(trackable(this), props);
  }

  /**
   * Read Securtity Data
   */
  Security.prototype.readSecuritySetting = m.action(function(result) {
    result = result || {};

    this.tenantFieldValue = result.tenantFieldValue;
    this.tenantFields = result.tenantFields;
    this.showTenantFieldValue = result.showTenantFieldValue;
    this.renderhtmlexport = result.setRenderhtmlexport;
    this.renderHtmlInReportViewerValue = result.renderHtmlInReportViewerValue;
    this.tenantFieldDefaultValue = result.tenantFieldDefaultValue;
    this.showTenantFieldDefaultValue = result.showTenantFieldDefaultValue;
    this.renderHtmlInReportViewerDefaultValue = result.renderHtmlInReportViewerDefaultValue;
    this.tenantId = result.tenantId;
    this.dataSecurityRuleSets = map(ruleSetInfo => new SecurityRulesSet(ruleSetInfo), result.dataSecurityRuleSets || []);

    this.modified = result.modified;

    // Reset Dirty
    this.resetDirty();
  });

  /**
   * Reset tenant field value
   */
  Security.prototype.resetTenantFieldValue = m.action(function() {
    this.tenantFieldValue = this.tenantFieldDefaultValue;
    this.markDirty();
  });

  /**
   * Update Tenant Field
   */
  Security.prototype.updateTenantField = m.action(function(value) {
    this.tenantFieldValue = value;
    this.markDirty();
  });

  /**
   * Add new Tenant Field
   */
  Security.prototype.addNewTenantField = m.action(function(newValue) {
    this.tenantFieldValue += ';' + newValue;
    this.markDirty();
  });

  /**
   * Update Show Tenant Field
   */
  Security.prototype.updateShowTenantField = m.action(function(value) {
    this.showTenantFieldValue = value;
    this.markDirty();
  });

  /**
   * Update Render HTML in export/printing  Value
  */
  Security.prototype.updateHtmlexport = m.action(function(value) {
    this.renderhtmlexport = value;
    this.markDirty();
  });

   /**
   * Update Render HTML In Report Viewer Value
   */
  Security.prototype.updateRenderHtmlInReportViewerValue = m.action(function(value) {
    this.renderHtmlInReportViewerValue = value;
    this.markDirty();
  });

  /**
   * Get System Tenant Fields
   */
  Security.prototype.getSystemTenantFields = function() {
    var tenantFields = this.tenantFields || [];
    return reduce(
      function(result, field) {
        if (field.isSystem) {
          result = result + field.name + ';';
        }
        return result;
      },
      '',
      tenantFields
    );
  };

   /**
   * Get Active Security Rules Sets
   */
  Security.prototype.getActiveSecurityRulesSet = function () {
    return filter(rulesSet => !rulesSet.isDeleted(), this.dataSecurityRuleSets);
  };

  /**
   * Create New Security Rules Set
   */
  Security.prototype.createNewSecurityRulesSet = function() {
    return new SecurityRulesSet();
  };

  /**
   * Add Security Rules Set
   */
  Security.prototype.addSecurityRulesSet = m.action(function(rulesSet) {
    rulesSet.markAsInserted();
    this.dataSecurityRuleSets.push(rulesSet);
    this.markDirty();
  });

  /**
   * Update Security Rules Set
   */
  Security.prototype.updateSecurityRulesSet = m.action(function(rulesSet) {
    var index = findIndex(item => item.tempId === rulesSet.tempId, this.dataSecurityRuleSets);
    if(index !== -1){
      this.dataSecurityRuleSets[index] = rulesSet;
    }
    this.markDirty();
  });

  /**
   * Move Security Rules Set
   */
  Security.prototype.moveSecurityRulesSet = m.action(function(oldPosititon, newPosititon, rulesSet) {
    this.dataSecurityRuleSets.splice(oldPosititon, 1);
    this.dataSecurityRuleSets.splice(newPosititon, 0, rulesSet);
    this.markDirty();
  });

  /**
   * Delete Rules Set
   */
  Security.prototype.deleteRulesSet = m.action(function(rulesSet) {
    rulesSet.markAsDeleted();
    this.markDirty();
  });

  /**
   * Reset Filters
   */
  Security.prototype.resetQuerySourceTreeFilters = m.action(function() {
    this.dataSourceQuerySourceTree.setFilter(null);
    this.fieldQuerySourceTree.setFilter(null);
  });

  /**
   * Populate dataSourceQuerySourceTree
   */
  Security.prototype.populateDataSourceQuerySourceTree = m.action(function(data, rulesSet) {
    var selectedQuerySourceIds = rulesSet.getSelectedQuerySourseIds();

    forEach(connection => {
      forEach(schema => {
        schema.querySources = filter(querySource => {
          if(querySource.type !== 'Function'){
            querySource.checked = includes(querySource.id, selectedQuerySourceIds);
            return true;
          }
        }, schema.querySources);
      }, connection.dbSource.querySources)
    }, data.connections);

    this.dataSourceQuerySourceTree.setQuerySources(data.connections);
  });

    /**
   * Populate fieldQuerySourceTree
   */
  Security.prototype.populateFieldQuerySourceTree = m.action(function(data, rulesSet) {
    var selectedQuerySourceFieldIds = rulesSet.getSelectedQuerySourseFieldIds();

    forEach(connection => {
      forEach(schema => {
        forEach(querySource => {
          forEach(querySourceField => {
            querySourceField.checked = includes(querySourceField.id, selectedQuerySourceFieldIds);
          }, querySource.querySourceFields)
        }, schema.querySources)
      }, connection.dbSource.querySources)
    }, data.connections);

    this.fieldQuerySourceTree.setQuerySources(data.connections);
  });

  /**
  * getSelectedQuerySourceIds
  */
  Security.prototype.getSelectedQuerySourceIds = function() {
    var querySourceIds = [];
    var connections = this.dataSourceQuerySourceTree.querySources;

    forEach(connection => {
      forEach(schema => {
        forEach(querySource => {
          if(querySource.checked){
            querySourceIds.push(querySource.id);
          }
        }, schema.querySources)
      }, connection.dbSource.querySources)
    }, connections);

    return querySourceIds;
  };

  /**
  * getSelectedQuerySourceFields
  */
  Security.prototype.getSelectedQuerySourceFields = function() {
  var querySourceFields = [];
  var selectedQuerySourceIds = this.getSelectedQuerySourceIds();
  var connections = this.fieldQuerySourceTree.querySources;

  forEach(connection => {
    forEach(schema => {
      forEach(querySource => {
        if(!includes(querySource.id, selectedQuerySourceIds)){
          return;
        }

        forEach(querySourceField => {
          if(querySourceField.checked){
            var field = {
              id: querySourceField.id,
              querySourceId: querySource.id
            };
            querySourceFields.push(field);
          }
        }, querySource.querySourceFields);

      }, schema.querySources)
    }, connection.dbSource.querySources)
  }, connections);

  return querySourceFields;
  };

  /**
   * Get Rules Sets For Saving
   */
  Security.prototype.getRulesSetsForSaving = function(){
    var rulesSets = [];
    var position = 1;
    forEach(rulesSet => {
      if(!rulesSet.isDeleted()){
        if(rulesSet.position !== position){
          rulesSet.updatePosition(position);
        }
        position += 1;
      }

      // disable because of backend needs
      //if(rulesSet.isChanged()){
      rulesSets.push(rulesSet.buildSaveData());
    }, this.dataSecurityRuleSets);
    return rulesSets;
  }

  /**
   * Build save data
   */
  Security.prototype.buildSaveData = function(tenantId) {
    return {
      tenantFieldValue: this.tenantFieldValue,
      showTenantFieldValue: this.showTenantFieldValue,
      renderHtmlInReportViewerValue: this.renderHtmlInReportViewerValue,
      tenantId: tenantId,
      setRenderhtmlexport: this.renderhtmlexport,
      modified: this.modified,
      dataSecurityRuleSets: this.getRulesSetsForSaving()
    };
  };

  /**
   * Reset error message
   */
  Security.prototype.resetErrorMessage = function() {
    this.alertMessage = commonMessages.EMPTY_MESSAGE;
  };

  /**
   * Show alert message after save
   */
  Security.prototype.showAlertMessage = function(result) {
    var message = localizer.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED');
    if (!result.success) {
      var messageData = result.messages[0];
      if (isObject(messageData)) {
        message = messageData.messages;
      } else {
        message = messageData;
      }
    }

    this.alertMessage = {
      type: result.success ? 'success' : 'error',
      message: message
    };
    return null;
  };

  module.exports = Security;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.Security.js